import { Helmet } from 'react-helmet'
import { useParams, useSearchParams } from 'react-router'

import { Card } from '@/components/ui/card'
import { ToggleTabs } from '@/components/ui/ToggleTabs'
import { EndorsementQueueView, useInternalEndorsements } from '@/models/internalEndorsement'
import { QUEUE_VIEWS } from './endorsementCopy'
import { EndorsementDetail } from './EndorsementDetail'
import { EndorsementQueue } from './EndorsementQueue'

const VIEWS = new Set<string>(Object.values(EndorsementQueueView))

/** Customers' policy change requests across every org, and the one staff are working on beside them. */
export function InternalEndorsements() {
  const { requestId } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const asked = searchParams.get('view') ?? ''
  const view = VIEWS.has(asked) ? (asked as EndorsementQueueView) : EndorsementQueueView.NEEDS_ACTION
  const { rows, isLoading, isError } = useInternalEndorsements(view)

  return (
    <>
      <Helmet>
        <title>Endorsements</title>
      </Helmet>
      <div className="flex flex-col gap-5">
        <div>
          <div className="text-2xl font-semibold">Endorsements</div>
          <p className="mt-1 text-sm text-neutral-600">
            Customers&rsquo; policy change requests, from review to the new COI.
          </p>
        </div>
        <ToggleTabs
          items={QUEUE_VIEWS}
          value={view}
          onValueChange={(next) => setSearchParams({ view: next })}
        />
        <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-[320px_minmax(0,1fr)]">
          <EndorsementQueue
            rows={rows}
            isLoading={isLoading}
            isError={isError}
            view={view}
            selectedId={requestId}
          />
          {requestId ? (
            <EndorsementDetail requestId={requestId} />
          ) : (
            <Card className="px-4 py-6 text-sm text-neutral-600">Pick a request to work on it.</Card>
          )}
        </div>
      </div>
    </>
  )
}
